import Login from './login'

export default {
    title: 'Login',
    drawer: false,
    exact: true,
    authentication: true,
    path: '/signin',
    component: Login,
    layout: {
        fullscreen: true
    }
}